<template>
    <div>
        <div
            v-if="canCreate"
            :class="{
                'mb-2': canCreate && attachments?.length > 0,
            }"
        >
            <file-upload
                :key="componentKey"
                :disabled="disabled"
                :drop-area-label="dropAreaLabel"
                :drop-area-hint="dropAreaHint"
                :accepted-file-types="acceptedFileTypes"
                :invalid-feedback="form.errors.attachments"
                @uploadCompleted="onUploadCompleted"
                @upload-started="emits('upload-started')"
                @upload-completed="emits('upload-completed')"
                @upload-failed="emits('upload-failed')"
            />
        </div>
        <file-list
            v-if="attachments && attachments?.length"
            :attachments="attachments"
            :can-delete="canDelete"
            :can-edit="canEdit"
            :can-read="canRead"
            @deleted="emits('deletedAttachment', $event)"
            @updated="emits('updatedAttachment', $event)"
        />
    </div>
</template>
<script setup>
import FileList from '@/Components/FileList.vue';
import FileUpload from '@/Components/FileUpload.vue';
import { ref } from 'vue';
import { useForm } from '@inertiajs/vue3';

const componentKey = ref(0);

const props = defineProps({
    attachments: Array,
    storeRoute: String,
    form: Object,
    canCreate: Boolean,
    canDelete: Boolean,
    canRead: Boolean,
    canEdit: Boolean,
    showEmptyState: Boolean,
    disabled: {
        type: Boolean,
        default: false,
    },
    dropAreaLabel: {
        type: String,
        default: null,
    },
    dropAreaHint: {
        type: String,
        default: null,
    },
    acceptedFileTypes: {
        type: Array,
        default: null,
    },
});

const emits = defineEmits(['success', 'updatedAttachment', 'deletedAttachment', 'upload-started', 'upload-completed', 'upload-failed']);
const form = props.form || useForm({ attachments: [] });

const onUploadCompleted = (fileIds) => {
    form.attachments = fileIds;

    if (!!props.form || !props.storeRoute) {
        return;
    }

    form.post(props.storeRoute, {
        preserveScroll: true,
        onSuccess: () => {
            form.reset();
            componentKey.value++;
            emits('success');
        },
    });
};
</script>
